export const FETCH_ALL_REPORTS = "FETCH_ALL_REPORTS";
export const FETCH_REPORT = "FETCH_REPORT";
export const CREATE_REPORT = "CREATE_REPORT";
export const UPDATE_REPORT = "UPDATE_REPORT";
export const DELETE_REPORT = "DELETE_REPORT";
